import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import QuoteSettings from './QuoteSettings'

const BUILD = process.env.REACT_APP_BUILD_TIME || 'dev'

const GearIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
  </svg>
)

export default function AppBar({ session }) {
  const navigate = useNavigate()
  const location = useLocation()
  const [showSettings, setShowSettings] = useState(false)

  const handleSignOut = async () => {
    await supabase.auth.signOut()
  }

  const nav = [
    { label: 'Projects', path: '/projects' },
    { label: 'Quotes',   path: '/quotes'   },
    { label: 'Orders',   path: '/orders'   },
    { label: 'My Items', path: '/catalogue' },
  ]

  return (
    <header className="ak-topbar">
      <div className="ak-topbar-inner">
        <div className="ak-brand" onClick={() => navigate('/projects')} style={{ cursor: 'pointer' }}>
          Akkord<span className="dot">.</span>
        </div>
        <nav className="ak-nav">
          {nav.map(({ label, path }) => (
            <button
              key={path}
              className={'ak-nav-item' + (location.pathname.startsWith(path) ? ' active' : '')}
              onClick={() => navigate(path)}
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="ak-topbar-right">
          <span className="ak-build">build {BUILD}</span>
          <button className="ak-tb-btn" onClick={() => setShowSettings(true)}>
            <GearIcon /> Settings
          </button>
          <button className="ak-tb-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>
      {showSettings && <QuoteSettings session={session} onClose={() => setShowSettings(false)} />}
    </header>
  )
}
